import React, { Component } from 'react'
import Form from '../../old_Components/ATS/onboard'
import { isATSEnabled, onboard } from '../../action/auth';
import constant from '../../constant';
import swal from 'sweetalert';
export default class Onboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ATS_ENABLED: 0,
            showLoader: false
        }


    }
    componentDidMount() {
        document.title = constant.title.ATS_CANDIDATE_ONBOARD
        isATSEnabled().then(res => {
            if (res.status) {
                this.setState({ ATS_ENABLED: res.result })
                if (res.result == 0) {
                    this.props.history.push(constant.component.Dashboard.url)
                }
            }
        })

    }
    onSubmit = (formData) => {
        this.setState({ showLoader: true })
        onboard(formData).then(res => {
            this.setState({ showLoader: false })
            if (res.status) {
                swal({
                    icon: "success",
                    text: res.result.message,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
                setTimeout(window.location.reload(), 2000)
            }
            else {
                swal({
                    icon: "error",
                    text: res.error,
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            }
        })
    }
    render() {
        const { showLoader } = this.state
        return (
            <React.Fragment>
                {/* {showLoader && <Loader />} */}
                <Form
                    showLoader={showLoader}
                    onSubmit={(formData) => { this.onSubmit(formData) }}
                />
            </React.Fragment>
        )
    }
}
